import { Serializable } from "./app/serializable";

export class CheckBoxText extends Serializable {
  public TranslateKey: string;
  public Values: object;
}



// WEBPACK FOOTER //
// ./src/model/myria/CheckBoxText.ts